import React from "react";
import { Link } from "react-router-dom";
import { TASK_STATUS } from "./constant";
import "./TodosTable.css";

import { displayDateTime } from "../../utils/dateDisplay";
const URGENCY_MAP = {
  1: "High",
  2: "Medium",
  3: "Low",
};

const { COMPLETED, UNCOMPLETED } = TASK_STATUS;
const TODO_STATUS_MAP = {
  [COMPLETED]: {
    newStatus: UNCOMPLETED,
  },
  [UNCOMPLETED]: {
    newStatus: COMPLETED,
  },
};

const formatPmsNotes = (notes) =>
  [...notes]
    .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
    .map((note) => {
      const ts = displayDateTime(note.created_at);
      return `[${ts} - ${note.author_name}] ${note.content}`;
    })
    .join("\n");

const TodosTable = ({
  readOnly = false,
  todos,
  selectedId,
  assignees = [],
  users = [],
  onEdit,
  handleUpdateTodoStatus,
  onDelete,
}) => {
  const safeTodos = Array.isArray(todos) ? todos : [];
  // Names are looked up among all users, including disabled and IT staff
  // accounts, so a todo keeps showing who created or last updated it after
  // that account is disabled. `assignees` is the filtered list.
  const directory = users.length > 0 ? users : assignees;
  const getUserFullName = (id) => {
    const user = directory.find((user) => user.uid === id);
    return user ? `${user.firstName} ${user.lastName}` : "";
  };

  return (
    <table className="table is-striped is-fullwidth todos-tbl is-size-7">
      <thead>
        <tr className="has-background-info-light">
          <th style={{ width: "10%" }}>{readOnly ? "Patient" : ""}</th>
          <th style={{ width: "10%" }}>Created By</th>
          <th style={{ width: "10%" }}>Creation Datetime</th>
          <th style={{ width: "10%" }}>Last Updated By</th>
          <th style={{ width: "5%" }}>Urgency</th>
          <th style={{ width: "10%" }}>Status</th>
          <th style={{ width: "10%" }}>Assigned To</th>
          <th style={{ width: "10%" }}>Specialty</th>
          <th style={{ width: "10%" }}>Due Date</th>
          <th style={{ width: "30%" }}>Description</th>
          <th style={{ width: "5%" }}></th>
        </tr>
      </thead>
      <tbody>
        {safeTodos.length === 0 ? (
          <tr>
            <td colSpan={11} className="has-text-centered">
              NO TODOS
            </td>
          </tr>
        ) : (
          safeTodos.map((todo, idx) => (
            <tr key={idx} className={todo.status}>
              {readOnly ? (
                <td>{todo.client_full_name}</td>
              ) : (
                <td>
                  {todo.id === selectedId ? (
                    <span className="icon has-text-primary">
                      <i className="fas fa-check"></i>
                    </span>
                  ) : null}
                </td>
              )}
              <td>{getUserFullName(todo.created_by) || todo.created_by_display_name || ""}</td>
              <td>{todo.creation_date_time}</td>
              <td>{getUserFullName(todo.updated_by)}</td>
              <td className={Number(todo.urgency) === 1 ? "has-text-danger" : ""}>{URGENCY_MAP[todo.urgency]}</td>
              <td>{todo.status}</td>
              <td>{getUserFullName(todo.assigned_to)}</td>
              <td>{todo.client_speciality || ""}</td>
              <td>{todo.due_date}</td>
              <td style={{ whiteSpace: "pre-line" }}>
                {todo.description}
                {Array.isArray(todo.pms_notes) && todo.pms_notes.length > 0 && (
                  <div style={{ color: "#888", marginTop: 4, fontSize: "0.9em" }}>{formatPmsNotes(todo.pms_notes)}</div>
                )}
              </td>
              <td>
                {readOnly ? (
                  <div className="icon-container">
                    <Link to={todo.link}>
                      <span className="icon">
                        <i className="fas fa-link"></i>
                      </span>
                    </Link>
                    <span
                      className="icon"
                      onClick={() => {
                        onDelete(todo.id);
                      }}
                    >
                      <i className="fas fa-trash"></i>
                    </span>
                  </div>
                ) : (
                  <>
                    <span
                      className="icon"
                      onClick={() => {
                        onEdit(todo.id);
                      }}
                    >
                      <i className="fas fa-edit"></i>
                    </span>
                    <span
                      className="icon"
                      onClick={() => {
                        const { id, status } = todo;
                        const newStatus = TODO_STATUS_MAP[status].newStatus;
                        handleUpdateTodoStatus(id, newStatus);
                      }}
                    >
                      <i className="fas fa-check"></i>
                    </span>
                  </>
                )}
              </td>
            </tr>
          ))
        )}
      </tbody>
    </table>
  );
};

export default TodosTable;
